var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBellPlusLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 135.967,
    height: 98,
    viewBox: "0 0 135.967 98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BellPlus-Logo",
    transform: "translate(-646.703 -746.077)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    transform: "translate(700.86 804.009)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(646.703 776.829)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M680.847,927.891a20.267,20.267,0,0,0-6.319-4.272h0a19.539,19.539,0,0,0-7.793-1.559H655.246V906.342H646.7V942a19.61,19.61,0,0,0,1.559,7.748,20.185,20.185,0,0,0,10.725,10.725,20.138,20.138,0,0,0,15.541,0,19.858,19.858,0,0,0,6.322-4.318,20.628,20.628,0,0,0,4.271-6.406,20.142,20.142,0,0,0,0-15.541A20.27,20.27,0,0,0,680.847,927.891Zm-14.112,25.6A11.423,11.423,0,0,1,655.246,942V930.6h11.489a11.192,11.192,0,0,1,4.432.885,11.472,11.472,0,0,1,6.084,6.084,11.183,11.183,0,0,1,.886,4.432,11.417,11.417,0,0,1-6.97,10.6A11.187,11.187,0,0,1,666.735,953.492Z",
    transform: "translate(-646.703 -906.168)",
    fill: "#085dad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M896.9,1015.871a11.247,11.247,0,0,1-12.6,2.428l21.627-21.626-2.98-2.98a19.615,19.615,0,0,0-6.635-4.408,20.088,20.088,0,0,0-15.041,0,19.617,19.617,0,0,0-6.635,4.408,19.147,19.147,0,0,0-4.365,6.594,20.481,20.481,0,0,0-1.424,7.475,20.808,20.808,0,0,0,1.423,7.517,19.043,19.043,0,0,0,4.365,6.639,19.957,19.957,0,0,0,28.312,0l2.98-2.979-6.047-6.046ZM880.14,999.107Zm8.52-2.783a11.276,11.276,0,0,1,4.625.988c-.812.808-1.838,1.82-3.058,3.015-1.536,1.508-3.094,3.051-4.63,4.587l-7.34,7.339a10.993,10.993,0,0,1-.951-4.491,11.106,11.106,0,0,1,3.38-8.109h0a10.9,10.9,0,0,1,6.286-3.208A12.062,12.062,0,0,1,888.661,996.324Z",
    transform: "translate(-825.983 -971.926)",
    fill: "#085dad"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 8.543,
    height: 55.692,
    transform: "translate(83.551)",
    fill: "#085dad"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 8.543,
    height: 55.692,
    transform: "translate(97.338)",
    fill: "#085dad"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M1187.313,762.123h-16.047V746.077h-7.118v16.047H1148.1v7.118h16.046v16.047h7.118V769.241h16.047Z",
    transform: "translate(-404.644)",
    fill: "#8cc739"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(647.106 839.444)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M649.723,1230.12l1.043,3.57,1.037-3.57h.855l1.043,3.57,1.03-3.57h.894l-1.5,4.535h-.9l-1.011-3.4-1.023,3.4h-.894l-1.5-4.535Z",
    transform: "translate(-648.79 -1230.081)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M690.121,1230.12v.758h-2.455V1232h2.2v.758h-2.2v1.14H690.2v.758h-3.4v-4.535Z",
    transform: "translate(-679.463 -1230.081)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M718.846,1230.709c-.408,0-.674.149-.674.428,0,.919,2.436.421,2.43,2.047,0,.849-.739,1.341-1.736,1.341a2.943,2.943,0,0,1-1.918-.726l.363-.732a2.551,2.551,0,0,0,1.568.667c.486,0,.778-.181.778-.5,0-.946-2.436-.408-2.436-2.021,0-.79.68-1.3,1.7-1.3a3.09,3.09,0,0,1,1.639.479l-.35.752A2.9,2.9,0,0,0,718.846,1230.709Z",
    transform: "translate(-703.795 -1229.919)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M741.016,1230.12v1.937h2.261v-1.937h.868v4.535h-.868v-1.84h-2.261v1.84h-.868v-4.535Z",
    transform: "translate(-722.518 -1230.081)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M769.659,1232.278a2.42,2.42,0,1,1-2.416-2.293A2.326,2.326,0,0,1,769.659,1232.278Zm-3.945,0a1.538,1.538,0,0,0,1.542,1.529,1.522,1.522,0,1,0-1.542-1.529Z",
    transform: "translate(-742.434 -1229.972)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M795.38,1233.916a1.05,1.05,0,0,0,1.121-1.153v-2.644h.868v2.644a2,2,0,0,1-4,0v-2.644h.868v2.644A1.073,1.073,0,0,0,795.38,1233.916Z",
    transform: "translate(-765.466 -1230.081)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M820.5,1230.12v.771h-1.412v3.764h-.875v-3.764H816.8v-.771Z",
    transform: "translate(-784.38 -1230.081)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M852.221,1232.278a2.42,2.42,0,1,1-2.417-2.293A2.326,2.326,0,0,1,852.221,1232.278Zm-3.946,0a1.539,1.539,0,0,0,1.542,1.529,1.522,1.522,0,1,0-1.542-1.529Z",
    transform: "translate(-809.064 -1229.972)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M877.942,1233.916a1.05,1.05,0,0,0,1.121-1.153v-2.644h.868v2.644a2,2,0,0,1-4,0v-2.644h.868v2.644A1.073,1.073,0,0,0,877.942,1233.916Z",
    transform: "translate(-832.096 -1230.081)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M903.062,1230.12v.771H901.65v3.764h-.875v-3.764h-1.412v-.771Z",
    transform: "translate(-851.009 -1230.081)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M931.434,1233.172v1.484h-.868V1233.2l-1.691-3.084h.881l1.237,2.132,1.218-2.132h.875Z",
    transform: "translate(-874.827 -1230.081)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M956.473,1232.278a2.42,2.42,0,1,1-2.417-2.293A2.326,2.326,0,0,1,956.473,1232.278Zm-3.946,0a1.539,1.539,0,0,0,1.542,1.529,1.522,1.522,0,1,0-1.542-1.529Z",
    transform: "translate(-893.199 -1229.972)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M982.194,1233.916a1.05,1.05,0,0,0,1.121-1.153v-2.644h.868v2.644a2,2,0,0,1-4,0v-2.644h.868v2.644A1.073,1.073,0,0,0,982.194,1233.916Z",
    transform: "translate(-916.23 -1230.081)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M1009.071,1234.655l-.784-1.341a1.256,1.256,0,0,1-.162.007H1007.1v1.334h-.868v-4.535h1.892c1.173,0,1.84.564,1.84,1.562a1.475,1.475,0,0,1-.9,1.47l1,1.5Zm-1.969-2.1h1.024c.648,0,1.011-.278,1.011-.849s-.363-.829-1.011-.829H1007.1Z",
    transform: "translate(-937.257 -1230.081)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M1044.157,1231.254a1,1,0,0,1-.791,1,1.109,1.109,0,0,1,.965,1.147c0,.777-.641,1.25-1.678,1.25h-2.073v-4.535h2.015C1043.561,1230.12,1044.157,1230.554,1044.157,1231.254Zm-.888.155c0-.343-.272-.544-.719-.537h-1.1v1.1h1.1C1043,1231.973,1043.27,1231.766,1043.27,1231.409Zm.162,1.886c0-.37-.33-.6-.881-.59h-1.1v1.2h1.1C1043.1,1233.91,1043.432,1233.683,1043.432,1233.295Z",
    transform: "translate(-964.977 -1230.081)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M1067.224,1234.655l-.784-1.341a1.252,1.252,0,0,1-.162.007h-1.023v1.334h-.868v-4.535h1.892c1.173,0,1.84.564,1.84,1.562a1.475,1.475,0,0,1-.9,1.47l1,1.5Zm-1.969-2.1h1.023c.648,0,1.011-.278,1.011-.849s-.363-.829-1.011-.829h-1.023Z",
    transform: "translate(-984.188 -1230.081)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M1089.258,1233.7h-2.216l-.4.959h-.9l1.989-4.535h.9l1.963,4.535h-.933Zm-.311-.745-.791-1.905-.8,1.905Z",
    transform: "translate(-1001.421 -1230.081)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M1114.565,1230.12l2.339,3.1v-3.1h.842v4.535h-.823l-2.332-3.1v3.1h-.849v-4.535Z",
    transform: "translate(-1024.019 -1230.081)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M1144.516,1232.387a2.248,2.248,0,0,1-2.4,2.268h-1.853v-4.535h1.885A2.232,2.232,0,0,1,1144.516,1232.387Zm-.888.007a1.452,1.452,0,0,0-1.49-1.51h-1v3.006h1.037A1.426,1.426,0,0,0,1143.629,1232.394Z",
    transform: "translate(-1045.425 -1230.081)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M1164.893,1249.549a.445.445,0,1,1-.888,0,.444.444,0,1,1,.888,0Z",
    transform: "translate(-1064.583 -1245.39)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M1172.447,1249.549a.445.445,0,1,1-.888,0,.444.444,0,1,1,.888,0Z",
    transform: "translate(-1070.679 -1245.39)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M1180.371,1234.43a.445.445,0,1,1-.888,0,.444.444,0,1,1,.888,0Zm-.039-4.075v1.127l-.143,1.885h-.525l-.143-1.885v-1.127Z",
    transform: "translate(-1077.074 -1230.271)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M1187.823,1234.43a.445.445,0,1,1-.888,0,.444.444,0,1,1,.888,0Zm-.039-4.075v1.127l-.142,1.885h-.525l-.143-1.885v-1.127Z",
    transform: "translate(-1083.088 -1230.271)",
    fill: "#4d4d4d"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellPlusLogo);
export default __webpack_public_path__ + "static/media/BellPlus-Logo.93a6e948a3eb68bc084b1209f274d545.svg";
export { ForwardRef as ReactComponent };